import SignalRConnection from '../services/SignalRConnection';
import Logger from '../services/LoggerService';

export class AnnouncementHub {
  private connection: SignalRConnection;

  constructor (readonly _tokenEndpoint: string, readonly _hubEndpoint: string) {
    this.connection = new SignalRConnection(_tokenEndpoint, _hubEndpoint);
  }

  public set onAnnouncement (value: ((message: Announcement) => void) | undefined) {
    this.register('BroadcastAnnouncement', value);
  }

  private register (methodName: string, onMessage: ((...args: any[]) => void) | undefined) {
    if (onMessage) {
      this.connection.on(methodName, onMessage);
    } else {
      this.connection.off(methodName);
    }
  }

  connect (): Promise<void> {
    return this.connection.connect();
  }

  async joinAnnouncements (eventId: number): Promise<AnnouncementsJoinResult> {
    return await this.connection.invoke('JoinAnnouncements', eventId);
  }
}

export interface Announcement {
  id: string;
  type: AnnouncementType;
  message: string;
}

export enum AnnouncementType {
  ComingUp = 'comingUp',
  Warning = 'warning',
  Info = 'info',
  Danger = 'danger'
}

export interface AnnouncementsJoinResult {
  joined: boolean;
  failedToJoinMessage: string;
  announcements: Announcement[];
  userGuid: string;
}
